import {Service} from '../../../service';

export class InvoiceDetailReportService extends Service {

  static entity = 'api/app/order-report';

  static getList(params: any): Promise<any> {
    return this.axios.get(`${this.entity}`, {params}).then(res => res.data);
  }

  static getSummary(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/total-columns`, {params}).then(res => res.data);
  }

  static downloadExcel(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/file-excel`, {params, responseType: 'blob'}).then(res => res.data);
  }

  static downloadGroupExcel(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/group-excel`, {params, responseType: 'blob'}).then(res => res.data);
  }

  static downloadPdf(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/file-pdf`, {params, responseType: 'blob'}).then(res => res.data);
  }

  static downloadCreatorNameExcel(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/creator-name-excel`, {params, responseType: 'blob'}).then(res => res.data);
  }
  
  static downloadProductCodeExcel(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/product-code-excel`, {params, responseType: 'blob'}).then(res => res.data);
  }

}
